<div class="strategy-tabs">
  <div class="strategy-tabs-container">
    <div
      id="sl-tab-investment"
      class="tab-item"
      data-cy="strategy-tab-investment"
      *ngIf="!is3aPillar && step !== 5"
      [ngClass]="{ 'col-4': step >= 2, disabled: step === 1 && highestTabIndex < 2, active: tabSelected === 2 }"
      (click)="tabNavigation(2)"
    >
      <div>
        <span [ngClass]="getTabIcon(2)"></span>
        <p>{{ 'new_strategy.navigation.investment' | translate }}</p>
        <p class="tab-label-mobile">{{ 'new_strategy.investment_screen.h2_mobile_view' | translate }}</p>
      </div>
    </div>

    <div
      id="sl-tab-risk"
      class="tab-item"
      data-cy="strategy-tab-risk"
      *ngIf="!is3aPillar"
      [ngClass]="{ 'col-4': step >= 2, disabled: step === 1 && highestTabIndex < 3, active: tabSelected === 3 }"
      (click)="tabNavigation(3)"
    >
      <div>
        <span [ngClass]="getTabIcon(3, is3aPillar)"></span>
        <p>{{ 'new_strategy.navigation.risk' | translate }}</p>
        <p class="tab-label-mobile">{{ 'new_strategy.navigation.risk_mobile_view' | translate }}</p>
      </div>
    </div>

    <div
      id="sl-tab-risk"
      class="tab-item"
      data-cy="strategy-tab-risk"
      *ngIf="is3aPillar"
      [ngClass]="{ 'col-4': step >= 2, active: tabSelected <= 3 }"
      (click)="tabNavigation(3)"
    >
      <div>
        <span [ngClass]="getTabIcon(3, is3aPillar)"></span>
        <p>{{ 'new_strategy.navigation.risk' | translate }}</p>
        <p class="tab-label-mobile">{{ 'new_strategy.navigation.risk_mobile_view' | translate }}</p>
      </div>
    </div>

    <div
      id="sl-tab-strategy"
      class="tab-item"
      [ngClass]="{ 'col-4': step >= 2, active: tabSelected > 3, disabled: step === 1 && highestTabIndex < 4 }"
      (click)="tabNavigation(4)"
    >
      <div>
        <span [ngClass]="getTabIcon(4, is3aPillar)"></span>
        <p>
          {{ 'new_strategy.navigation.review' | translate }}
        </p>
        <p class="tab-label-mobile">
          {{ 'new_strategy.navigation.review' | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
